import { store } from '../store'

const isQueryEqual = () =>
  Object.is(store.getState().currentQuery, store.getState().query)

export default isQueryEqual
